import { useGetSession } from '@repo/api/auth/useGetSession';
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { Loading } from '@/components/ui/loading';
import { useAuthEventListener } from '@/hooks/auth-event';
import { useCredentials, useRemoveCredentials } from '@/store/auth-store';

export function PrivateRoutes() {
  useAuthEventListener();
  const { isLoading, isError } = useGetSession();
  const location = useLocation();
  const removeCredentials = useRemoveCredentials();
  // read before the effect below clears the store, so the login page can still
  // offer to restore `from` for the same user
  const userId = useCredentials().id;

  // credentials are persisted to localStorage, which outlives the session
  // cookie. Without this the app boots believing it is signed in and renders an
  // authenticated shell whose every request fails.
  useEffect(() => {
    if (isError) removeCredentials();
  }, [isError, removeCredentials]);

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (isError) {
    return <Navigate to="/login" replace state={{ from: location, userId }} />;
  }

  return <Outlet />;
}
